<template>
  <div class="menu_item" @click="movePage()">
    <div class="image-container">
      <img :src="`${image}?v=1`" :class="{ coin: label === 'Coin', rewards: label === 'Rewards' }" />
      <!-- カートバッジの追加 -->
      <div v-if="label === 'Cart' && cartItemCount > 0" class="cart-badge">
        <!-- {{ cartItemCount > 99 ? '99+' : cartItemCount }} -->
      </div>
    </div>
    <span>{{ label }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    cartItemCount: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  methods: {
    movePage() {
      if (this.label !== 'HOME'
        && this.label !== 'SHOP'
        && this.label !== 'Sell To us'
        && this.label !== 'Rewards'
        && this.currentUser.is_login === '0') {
        if (this.label === 'My Page') {
          this.$router.push('/login?redirect=' + encodeURIComponent('/user-menu'));
        } else {
          this.$router.push('/login');
        }
        return;
      }
      if (this.label === 'My Page' || this.label === 'Cart' || !this.url) {
        this.$emit('handleClick', this.label);
        return;
      }
      if (this.url.startsWith('http')) {
        // window.open(this.url, '_blank').focus();
        window
          .open(this.url, '_self')
          .focus();
      } else {
        this.$router.push(this.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_item {
  display: flex;
  height: 60px;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  font-size: 12px;
  justify-content: space-around;
  cursor: pointer;
  @media screen and (max-width: $tabletWidth) {
    height: 40px;
    font-size: 10px;
  }

  .image-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    @media screen and (max-width: $tabletWidth) {
      height: 28px;
    }
  }

  img {
    width: 36px;
    // height: 60px;
    &.coin {
      width: 55px;
    }
    &.rewards {
      width: 50px;
    }
    @media screen and (max-width: $tabletWidth) {
      width: 28px;
      // height: 38px;
      &.coin {
        width: 40px;
      }
      &.rewards {
        width: 38px;
      }
    }
  }

  .cart-badge {
    position: absolute;
    top: -3px;
    right: -4px;
    background-color: #ff4444;
    color: white;
    border-radius: 10px;
    min-width: 10px;
    height: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: bold;
    padding: 0 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

    @media screen and (max-width: $tabletWidth) {
      top: -3px;
      right: -6px;
      font-size: 9px;
      border-radius: 8px;
    }
  }

  span {
    color: #6e6d6d;
    line-height: 8px;
    font-size: 14px;
    font-weight: bold;
    @media screen and (max-width: $tabletWidth) {
      font-size: 8px !important;
    }
  }
}
</style>
